/**
 * Which entity the HUD's target frame shows (combat.md §Control model): the SOFT target —
 * the enemy an ability press or F will act on (`pickSoftTarget`: explicit, then threat, then
 * nearest within `SOFT_TARGET_RADIUS_M`) — and nothing when there is none.
 *
 * Why it exists (story `q-stamina-bar-and-ability-animations`, owner phone playtest
 * 2026-10-23): the frame used to fall back to "the nearest enemy anywhere" in the area of
 * interest, so a full-health "Ruin Shade 210/210" sat on screen at Warden Sel's post with no
 * shade in view — an enemy no press would touch. The frame now names exactly the press's target.
 */
export function targetFrameEntity<E>(
  soft: { id: number } | null,
  entities: ReadonlyMap<number, E>,
): E | undefined {
  return soft ? entities.get(soft.id) : undefined;
}
